<template>
    <div class="form__group">
        <div class="form__row">
            <div class="form__multiselect">
                <label for="duration" class="form__label">Duration</label>
                <multiselect
                    id="duration"
                    :options="options"
                    :placeholder="placeholder"
                    :allow-empty="true"
                    label="label"
                    track-by="value"
                    :loading="loading"
                    v-model="selected"
                    :disabled="manuallyModified"
                    @input="updateValue"
                    :class="{ 'form__control': true, 'form__control--invalid': errors.first(this.name) }">
                    >
                    <span slot="noOptions">Type a name to search durations...</span>
                </multiselect>
            </div>
            <div>
                <label class="form__label" for="duration-overwrite">Manual Duration</label>
                <input
                    id="duration-overwrite"
                    class="form__control form__number"
                    type="number"
                    :disabled="presetSelected"
                    @keyup="manualOverride"
                    @mouseup="manualOverride"
                >
            </div>
        </div>
    </div>
</template>

<script>
    import AjaxSelect from '../../Form/Control/AjaxSelect';
    import ActivityDurations from '../../../resources/ActivityDurations';

    export default {
        name: 'DurationDropdown',
        mixins: [AjaxSelect],
        props: {
            value: {
                type: String|Number,
                default: ''
            },
            events: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                manuallyModified: false,
                presetSelected: false,
                options: ActivityDurations,
            }
        },
        created() {
          this.options.find(option => {
              if (option.value === this.value) {
                  this.selected = option;
              }
          });
        },
        methods: {
            updateValue(value, id) {
                this.$emit('input', value);
                this.manuallyModified = false;
                this.presetSelected = value !== null;
            },
            manualOverride(e) {
                const value = parseInt(e.target.value, 10) ? parseInt(e.target.value, 10) : -1;
                this.manuallyModified = value !== -1;
                this.$emit('input', value);
            },
            eventName(event) {
                return event.eventName;
            },
        }
    }
</script>

<style scoped lang="scss">
    .form__label {
        margin-bottom: 1rem;
        display: block;
    }
    .form__multiselect {
        flex: 0 0 70%;
    }
    .form__row {
        display: flex;
        gap: 1rem;
    }
    .form__number:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
</style>
